import {
  minBreakpoints,
  primaryRegularFont,
  primarySemiBoldFont,
  theme,
} from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { palette } from '@noths/polaris-design-system-theme-brand2026customer';
import { css } from 'styled-components';

const { spacing } = theme;

export const title = css`
  ${primaryRegularFont}
  ${theme.responsiveText.BODY.MD};
  color: var(--neutral-black-70);
  margin: 0 0 ${spacing.sm}px;
`;

export const link = css`
  display: flex;
  ${primarySemiBoldFont}
  ${theme.responsiveText.BODY.SM};
  color: ${palette.blueBase};
  margin: 0 0 ${spacing.md}px 0;
  text-decoration: none;
`;

export const sections = css`
  br {
    display: block;
    margin: ${spacing.md}px 0;
    height: 1px;
    content: '';
    background-color: var(--neutral-black-30);
  }
`;

export const smallScreensOnly = css`
  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      display: none;
    `,
  )}
`;

export const membershipSection = css`
  border-bottom: 1px solid var(--neutral-black-30);
  padding: 0 0 ${spacing.lg}px;
  margin: 0 0 ${spacing.lg}px;
`;

export const list = css`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const accountItem = css`
  display: flex;
  justify-content: center;
  padding: 8px 12px;
  border: 1px solid var(--brand-purple-base);
  border-radius: 18px;
  ${primarySemiBoldFont}
  ${theme.responsiveText.BODY.XS};
  background-color: var(--brand-purple-10);
  color: var(--brand-purple-base);
  text-decoration: none;
`;

export const accountItemIconContainer = css`
  display: flex;
  margin-right: 9px;
`;
